import PackageListPage from "./List";
import PackageDetailsPage from "./Details";

const Packages = {
  List: PackageListPage,
  Details: PackageDetailsPage,
};

export default Packages;
